import _ from '../../core/utils'

const REFRESH_CONFIG = {
    el: _.select( '.fl__edit-status--reload' )
}

export default REFRESH_CONFIG